/**
 * Component Entry
 *
 */

import InputMasked from './InputMasked'
export default InputMasked
export * from './InputMasked'
